export default "__VITE_ASSET__371241c4__"